import { useQuerySnackbar } from '@explorer/hooks';
import { ControlGetContactsResponse } from '@explorer/open-api-client';
import { useV1APIQuery } from '@explorer/query';

export const useQueryEscalationContacts = (params: {
  client_id: string;
  enabled?: boolean;
}) => {
  const { client_id, enabled = true } = params;
  const { snackError } = useQuerySnackbar();

  return useV1APIQuery<ControlGetContactsResponse>({
    queryKey: ['v1ControlWebAdminClientClientIdContactsGet', client_id],
    queryFn(client, context) {
      return client.v1ControlWebAdminClientClientIdContactsGet(
        {
          client_id,
        },
        {
          signal: context.signal,
        },
      );
    },
    explorerAPIOptions: {
      clientId: client_id,
      onError: (error) => {
        snackError('Failed to load escalation contacts', error);
      },
    },
    enabled,
    retry: false,
  });
};
